import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

//Match single
$(document).ready(function () {
  var i = 0;
  function getCombinations(input, size) {
    var results = [],
      result,
      mask,
      total = Math.pow(2, input.length);
    for (mask = 0; mask < total; mask++) {
      result = [];
      i = input.length - 1;
      do {
        if ((mask & (1 << i)) !== 0) {
          result.push(input[i]);
        }
      } while (i--);
  
      //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
      // if (result.length <= size && result.length > 0) {
      //perndryshe duhet ky
      if (result.length == size && result.length > 1) {
        results.push(result);
      }
    }
    //console.log(results);
    return results;
  }
  
  function treatCombinations(s) {
    var min = false;
    var max = [];
    var maxOdd = false;
    var arr = s;
    var l = arr.length;
    let value = 0;
    let element = document.getElementById("placeBetAreaValue");
    if (element && element.value)
      value = parseFloat(element.value) / l;
  

    for (; i < l; ) {
      (function (q) {
        var odd = value;
        for (var j in q) {
          odd = odd * q[j];
        }
        if (!min) {
          min = odd;
        } else if (odd < min) {
          min = odd;
        }
        if (!maxOdd) {
          maxOdd = odd;
        } else if (odd > maxOdd) {
          maxOdd = odd;
        }
        max.push(odd);
      })(arr[i]);
      i = i + 1;
    }
  
    let newMax = 0;
    for (let index = 0; index < max.length; index++) {
      const element = max[index];
      newMax += element;
    }
  
    return {
      min: min,
      max: max,
      maxOdd: maxOdd,
      combNo: l,
      newMax: newMax
    };
  }
  
  function calculatePrice(value) {
    if (!value) {
      value = document.getElementById("placeBetAreaValue").value;
    }
    var totalValue = 1;
  
    itemArray.forEach((item) => {
      totalValue = totalValue * item.coefVal;
    });
    totalValue = totalValue * value;
  
    const size = $("#systemBtn").val();
  
    if (size && size !== "-1") {
      const odds = [];
  
      itemArray.forEach((element) => {
        odds.push(element.coefVal);
      });
  
      var s = getCombinations(odds, size);
      var r = treatCombinations(s);
  
      $("#winningPrice")[0].innerHTML = `${_t('Fitimi')} ${Math.round(r.min * 100) / 100} / ${
        Math.round(r.newMax * 100) / 100
      }`;
    } else {
      document.getElementById("winningPrice").textContent = _t('Fitimi') + ' ' + Utils.formatNumber(totalValue);
    }
  }
  function calculateBetSlipCoef() {
    const reducer = (accumulator, currentValue) =>
      accumulator * currentValue.coefVal;
    var res = itemArray.reduce(reducer, 1);
    $("body #betCoefCount").text(
      (Math.floor(parseFloat(res) * 100) / 100).toFixed(2)
    );
  }
  calculateBetSlipCoef();

  $("#systemBtn").change(function () {
    $(".betTypeWrapper").removeClass("multipleActive");
    $(".betTypeWrapper").addClass("systemActive");
  });
  // const placeBetArea = document.getElementById("placeBetAreaValue");
  // const placeBetValue = document.getElementById("placeBetValue");
  //
  // placeBetArea.addEventListener("keyup", updateValue);
  //
  // function updateValue(e) {
  //   if (e.target.value == 0) {
  //     placeBetValue.textContent = 0;
  //
  //     calculatePrice(0);
  //   } else {
  //     placeBetValue.textContent = e.target.value;
  //     calculatePrice(e.target.value);
  //   }
  // }

  $(".singleBtn").on("click", function () {
    $("#systemBtn").children("option").remove();
    if (itemArray.length >= 3) {
      $("body .betTypeWrapper").addClass("systemAvailable");
      $(".betSlipSingleItem").each(function (i) {
        if (i === 1) {
          $("#systemBtn").append(`<option value="-1">${_t('System')}</option>`);
        }
        if (i >= 2) {
          $("#systemBtn").append(
            '<option class="systemBtnOption" value="' +
              i +
              '">' +
              i +
              "/" +
              itemArray.length +
              "</option>"
          );
        }
      });
    } else {
      $("body .betTypeWrapper").removeClass("systemAvailable");
    }
    $(".betTypeWrapper").addClass("multipleActive");
    $(".betTypeWrapper").removeClass("systemActive");
  });

  $("body").on("click", ".removeBetBtn", function (e) {
    var betId = $(this).parent().attr("bet-id");
    var gameId = 0;
    var removeIndex = itemArray
      .map(function (item) {
        //console.log(item);
        gameId = item.gameId;
        return item.coefId;
      })
      .indexOf(betId);
    itemArray.splice(removeIndex, 1);
    localStorage.setItem("addObject", JSON.stringify(itemArray));

    if (itemArray.length == 0)  localStorage.removeItem('coefHasChanged');

    const event = new CustomEvent("leaveRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);
    $(this).parent().remove();
    $(".bettingBtn").each((items, s) => {
      var getMatchBetId = $(s).attr("bet-id");
      if (getMatchBetId === betId) {
        $(s).removeClass("betSlipAdded");
      }
    });
    $(".betCount span").text(itemArray.length);

    calculatePrice();
    $("#systemBtn").children("option").remove();
    if (itemArray.length >= 3) {
      $("body .betTypeWrapper").addClass("systemAvailable");
      $(".betSlipSingleItem").each(function (i) {
        if (i === 1) {
          $("#systemBtn").append(`<option value="-1">${_t('System')}</option>`);
        }
        if (i >= 2) {
          $("#systemBtn").append(
            '<option class="systemBtnOption" value="' +
              i +
              '">' +
              i +
              "/" +
              itemArray.length +
              "</option>"
          );
        }
      });
    } else {
      $("body .betTypeWrapper").removeClass("systemAvailable");
    }
    $(".betTypeWrapper").addClass("multipleActive");
    $(".betTypeWrapper").removeClass("systemActive");

    if (itemArray.length == 0) {
      $("body .betSlip").addClass("hideMe");
      $("body .betSlip").removeClass("slideDown");
    }

    updateItemArray(itemArray);
    calculateBetSlipCoef();
  });

  $("body").on("change", "#systemBtn", function (e) {
    calculatePrice();
    updateItemArray(itemArray);
  });

  $("body").on("click", ".bettingBtn", function (e) {
    if ($(".betCount").hasClass("animate")) {
      $(".betCount").removeClass("animate");
      setTimeout(function () {
        $(".betCount").addClass("animate");
      }, 200);
    } else {
      $(".betCount").addClass("animate");
      setTimeout(function () {
        $(".betCount").removeClass("animate");
      }, 200);
    }

    let valuePlaced = $(e.currentTarget).children("span:last");
    let getBetGameId = $(e.currentTarget).attr("game-id");
    let getBetCoefId = $(e.currentTarget).attr("bet-id");
    let getBetCoefVal = $(e.currentTarget).attr("match-odd");
    let getBetHomeName = $(e.currentTarget).attr("match-home-name");
    let getBetAwayName = $(e.currentTarget).attr("match-away-name");
    let getBetName = getBetHomeName + " v " + getBetAwayName;
    let getBetMarket = $(e.currentTarget).attr("match-market");
    let marketBetName = $(e.currentTarget).attr("match-market-option");
    let isLive = $(e.currentTarget).attr("match-is-live");
    var addObject = {
      gameId: getBetGameId,
      coefId: getBetCoefId,
      coefVal: getBetCoefVal,
      getHomeName: getBetHomeName,
      getAwayName: getBetAwayName,
      gameName: getBetName,
      matchMarket: getBetMarket,
      marketOption: marketBetName,
      isLive:isLive,
    };

    if ($(e.currentTarget).hasClass("betSlipAdded")) {
      $(e.currentTarget).removeClass("betSlipAdded");

      let gameId = 0;

      //console.log('getBetCoefId',getBetCoefId)
      var removeIndex = itemArray
        .map(function (item) {
          gameId = item.gameId;
          return item.coefId;
        })
        .indexOf(getBetCoefId);
      //console.log('removeIndex',removeIndex)
      itemArray.splice(removeIndex, 1);
      //console.log(itemArray);
      localStorage.setItem("addObject", JSON.stringify(itemArray));
      if (itemArray.length == 0)  localStorage.removeItem('coefHasChanged');

      const event = new CustomEvent("leaveRoom", {
        detail: addObject.gameId,
      });
      window.dispatchEvent(event);
      $(".betSlipContent .betSlipSingleItem").each(function () {
        if ($(this).attr("bet-id") == getBetCoefId) {
          $(this).remove();
        }
      });
      $(".betCount span").text(itemArray.length);

      $("#systemBtn").children("option").remove();
      if (itemArray.length >= 3) {
        $("body .betTypeWrapper").addClass("systemAvailable");
        $(".betSlipSingleItem").each(function (i) {
          if (i === 1) {
            $("#systemBtn").append(`<option value="-1">${_t('System')}</option>`);
          }
          if (i >= 2) {
            $("#systemBtn").append(
              '<option class="systemBtnOption" value="' +
                i +
                '">' +
                i +
                "/" +
                itemArray.length +
                "</option>"
            );
          }
        });
      } else {
        $("body .betTypeWrapper").removeClass("systemAvailable");
      }
      $(".betTypeWrapper").addClass("multipleActive");
      $(".betTypeWrapper").removeClass("systemActive");

      console.log(itemArray.length);
    } else {
      if (getBetCoefVal == 1) {
        e.stopImmediatePropagation();
        e.stopPropagation();
      } else if (getBetCoefVal == "undefined") {
        if ($(valuePlaced).text() == "undefined") {
          $(valuePlaced).text("");
        }
      } else {
        $(".betSlipContent").append(
          '<div class="betSlipSingleItem" game-id="' +
            getBetGameId +
            '" bet-id="' +
            getBetCoefId +
            '">\n' +
            '               <div class="removeBetBtn">\n' +
            '                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>\n' +
            "               </div>\n" +
            '               <div class="betSlipSingleContent">\n' +
            '                 <div class="betSlipSingleDetails">\n' +
            
            `               <span class="betSlipSingleMatch"> ${getBetHomeName} - ${getBetAwayName} </span>\n` +
            `                   <span class="betSlipSingleType">  ${_t(getBetMarket)} ( ${_t(marketBetName)})</span>\n` +
            '                 <div class="betSlipSingleOdd ' +
            getBetCoefId +
            '-bs">\n' +
            "                   <span>" +
            getBetCoefVal +
            "</span>\n" +
            "                 </div>\n" +
            "                 </div>\n" +
            "               </div>\n" +
            "             </div>"
        );

        $(e.currentTarget).addClass("betSlipAdded");
        itemArray.push(addObject);
        localStorage.setItem("addObject", JSON.stringify(itemArray));
        //console.log('addObject: ', (itemArray));
        $(".betCount span").text(itemArray.length);
        $("#systemBtn").children("option").remove();
        if (itemArray.length >= 3) {
          $("body .betTypeWrapper").addClass("systemAvailable");
          $(".betSlipSingleItem").each(function (i) {
            if (i === 1) {
              $("#systemBtn").append(`<option value="-1">${_t('System')}</option>`);
            }
            if (i >= 2) {
              $("#systemBtn").append(
                '<option class="systemBtnOption" value="' +
                  i +
                  '">' +
                  i +
                  "/" +
                  itemArray.length +
                  "</option>"
              );
            }
          });
        } else {
          $("body .betTypeWrapper").removeClass("systemAvailable");
        }

        const event = new CustomEvent("addToRoom", {
          detail: addObject.gameId,
        });
        window.dispatchEvent(event);

        $(".betTypeWrapper").addClass("multipleActive");
        $(".betTypeWrapper").removeClass("systemActive");
      }

      if (itemArray.length == 0) {
        $("body .betSlip").addClass("hideMe");
      } else {
        $("body .betSlip").removeClass("hideMe");
      }
    }
    calculatePrice();

    $(".betSlip").removeClass("slideDown");

    updateItemArray(itemArray);
    calculateBetSlipCoef();
  });
});
